import {useQuery} from 'react-query';
import request from '../../axios';
import {IUtmResponse} from '../../../module/pdfFarmCreditReport/types';

interface ILoanValidationResult {
  overall_score: number;
  loan_validation_letter: string;
}

export const getFarmCadastre = async (loanGuid?: string) => {
  await request.post('api/v2/farm/bulk-lend-utm-report', {
    loan_request: loanGuid,
  });
  const {data}: {data: IUtmResponse[]} = await request.get(
    // const {data} = await request.get(
    'api/v2/farm/aggregated-lend-utm-report/loan-request/' + loanGuid,
  );
  return data;
};

const useGetFarmCadastre = (loanGuid?: string) => {
  const {data, isLoading} = useQuery({
    queryKey: ['farm-cadastre-result'],
    queryFn: () => getFarmCadastre(loanGuid),
    enabled: Boolean(loanGuid),
  });
  return {data, isLoading};
};

export default useGetFarmCadastre;
